import { graphql } from "react-relay";

export const userIntegrationFragment = graphql`
	fragment ActionItemIntegrationsUserIntegration on UserIntegrations {
		userLevelActionItemIntegration {
			id
			integrationProvider
			syncEnabled
			syncedActionItemCount
			unsyncedActionItemCount
			lastSyncDate
			integrationSpecificDetails {
				...MicrosoftTodoIntegrationUserIntegrationDetails
			}
		}
	}
`;

export const connectUserToIntegration = graphql`
	mutation ActionItemIntegrationsConnectUserMutation(
		$integrationProvider: IntegrationProvider!
		$destinationInfo: JSON!
		$syncEnabled: Boolean!
		$triggerManualSync: Boolean!
	) {
		connectUserToIntegration(
			input: {
				integrationProvider: $integrationProvider
				destinationInfo: $destinationInfo
				syncEnabled: $syncEnabled
				triggerManualSync: $triggerManualSync
			}
		) {
			viewer {
				integrations {
					...ActionItemIntegrationsUserIntegration
				}
			}
		}
	}
`;

export const disconnectUserFromIntegration = graphql`
	mutation ActionItemIntegrationsDisconnectUserMutation {
		disconnectUserFromIntegration(input: {}) {
			deletedUserIntegrationId
			viewer {
				integrations {
					...ActionItemIntegrationsUserIntegration
				}
			}
		}
	}
`;

export const toggleUserIntegrationSync = graphql`
	mutation ActionItemIntegrationsToggleSyncMutation($syncEnabled: Boolean!) {
		toggleUserIntegrationSync(input: { syncEnabled: $syncEnabled }) {
			viewer {
				integrations {
					userLevelActionItemIntegration {
						syncEnabled
					}
				}
			}
		}
	}
`;

export const syncIncompleteActionItems = graphql`
	mutation ActionItemIntegrationsSyncIncompleteActionItemsMutation {
		syncIncompleteActionItemsToUserIntegration(input: {}) {
			viewer {
				integrations {
					userLevelActionItemIntegration {
						unsyncedActionItemCount
						syncedActionItemCount
						lastSyncDate
					}
				}
			}
			result
		}
	}
`;
